<h1 mat-dialog-title class="mb-1">Identity verification consent</h1>

<div mat-dialog-content *ngIf="form$ | async; let form">
  <div>I confirm that I am authorised to provide the personal details that I will provide for the purpose of verifying my identity and I consent to my information being checked with the document issuer or official record holder via a third party system operated by GB Group Plc (<strong>GBG</strong>) for the purpose of confirming my identity. I agree that the Trustee and GBG, including their affiliates and subcontractors, may collect, hold, use, process, disclose, transfer or export any of the personal information that I have provided for the purpose of verifying my identity. GBG's privacy policies are available at: <a href="https://www.gbgplc.com/legal-and-regulatory/privacy-policy/" target="_blank" rel="noopener">www.gbgplc.com/legal-and-regulatory/privacy-policy/</a> and <a href="https://www.gbgplc.com/legal-and-regulatory/privacy-policy-anz/" target="_blank" rel="noopener">www.gbgplc.com/legal-and-regulatory/privacy-policy-anz/</a>.</div>

  <div class="mt-3">
    <app-checkbox [control]="form.controls.agree" title="I agree with the terms and conditions">
    </app-checkbox>
  </div>

</div>

<div mat-dialog-actions>
  <div class="consent-actions" *ngIf="form$ | async; let form">
    <app-button title="Close" color="link" (onClick)="onCancelClick()"></app-button>
    <app-button title="Agree" icon="arrow_forward" [isDisabled]="!form.value.agree" [isLoading]="consentSavingSelector"
      (onClick)="onAgreeClick()"></app-button>
  </div>
</div>
